exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-right { margin-right: 0px !important}\r\n.log {\r\n  margin: 5px 10px 0 0;\r\n}\r\n.navbar-default {\r\n\r\n}\r\ntable, th, td {\r\n   border: 1px solid black;\r\n   text-align: left;\r\n   padding: 15px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/App.css
// module id = 282
// module chunks = 0